import { Link } from 'react-router-dom'
import { usePostResetPasswordMutation } from '../../api/api'
import * as Yup from 'yup'
import { Formik } from 'formik'
import LoadingBlocker from '../../components/LoadingSpinner/LoadingBlocker'
import { useState } from 'react'

const ForgotPasswordView = () => {
  const [sendSuccessful, setSendSuccessful] = useState(null)
  const [postResetPassword, { isLoading, error }] =
    usePostResetPasswordMutation()
  const schema = Yup.object().shape({
    email: Yup.string().required('An email is required'),
  })

  function onSubmitReset(values) {
    postResetPassword(values.email).then((res) => {
      setSendSuccessful(true)
    })
  }

  return (
    <div className="flex w-full h-full items-center justify-center">
      <div className="bg-gray-light w-[500px] p-6 rounded drop-shadow-lg mb-10 relative">
        <h1 className="text-center mb-0">Forgot Password</h1>
        <p className="mt-4 mb-6">
          Enter the email associated with your account and we'll send you a
          password reset link.
        </p>
        {sendSuccessful && (
          <div className="p-4 bg-blue-dark rounded border border-blue mb-4">
            <p>A password reset link has been sent to your email.</p>
          </div>
        )}
        <Formik
          validationSchema={schema}
          initialValues={{ email: '', password: '' }}
          onSubmit={(values) => {
            onSubmitReset(values)
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => (
            <div className="login">
              <div className="form">
                <form noValidate onSubmit={handleSubmit}>
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    name="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    placeholder="Email"
                    className="form-control inp_text"
                    id="email"
                  />
                  <p className="error">
                    {errors.email && touched.email && errors.email}
                  </p>

                  <div className="flex justify-end pt-6">
                    <div>
                      <Link
                        className="button bg-transparent text-white-dark inline-block"
                        to="/login"
                      >
                        Back
                      </Link>
                    </div>
                    <div>
                      <button
                        className="button bg-pink hover:bg-pink-off"
                        type="submit"
                      >
                        Reset Password
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}
        </Formik>
        {isLoading && <LoadingBlocker />}
      </div>
    </div>
  )
}

export default ForgotPasswordView
